/**
 * VitaKind Cart Upsells – Bundle & Subscription Swap + Shipping-Protection Cleanup
 *
 * Shipping-protection cleanup relies on a server-side Liquid marker:
 * When only cart-hidden items remain, the cart drawer HTML contains
 * #vk-hidden-only-marker (a hidden <span> injected by Liquid).
 * A MutationObserver watches #CartDrawer-CartItems for this element
 * and triggers a cart clear when found.
 */
(function () {
  'use strict';

  var _origFetch = window._vkOrigFetch || window.fetch;

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' returned ' + r.status);
      return r.json();
    });
  }

  function refreshDrawer() {
    return _origFetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) throw new Error('no section html');
        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');
        var selectors = ['#CartDrawer-Contents', '#CartDrawer .drawer__inner', '#CartDrawer'];
        for (var i = 0; i < selectors.length; i++) {
          var newEl = doc.querySelector(selectors[i]);
          var curEl = document.querySelector(selectors[i]);
          if (newEl && curEl) { curEl.innerHTML = newEl.innerHTML; return; }
        }
        window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }

  // ─── Upsell swap ─────────────────────────────────────────────────────────────

  var _swapping = false;

  function handleClick(upsellEl) {
    var action       = upsellEl.dataset.vkAction;
    var removeId     = upsellEl.dataset.vkRemove;
    var addId        = upsellEl.dataset.vkAdd;
    var planId       = upsellEl.dataset.vkPlan || null;
    var itemPlanId   = upsellEl.dataset.vkItemPlan || null;
    var bundlePlanId = upsellEl.dataset.vkBundlePlan || null;

    if (action === 'bundle-swap' && itemPlanId && bundlePlanId) {
      planId = bundlePlanId;
    }

    var btn = upsellEl.querySelector('.vk-btn');
    if (btn) { btn.disabled = true; btn.textContent = '…'; }

    _swapping = true;

    post('/cart/change.js', { id: removeId, quantity: 0 })
      .then(function () {
        var payload = { id: addId, quantity: 1 };
        if (planId) payload.selling_plan = parseInt(planId, 10);
        return post('/cart/add.js', payload);
      })
      .then(function () { return refreshDrawer(); })
      .then(function () { _swapping = false; })
      .catch(function (err) {
        _swapping = false;
        console.error('[VitaKind Upsell]', err);
        window.location.reload();
      });
  }

  // ─── Shipping-Protection Cleanup ─────────────────────────────────────────────
  // Liquid injects <span id="vk-hidden-only-marker"> inside #CartDrawer-CartItems
  // when only cart-hidden items remain. We watch for this element after every
  // drawer re-render (Shrine replaces innerHTML, so the marker appears in the DOM).

  var _clearDebounce = null;

  function clearHiddenOnlyCart() {
    if (_swapping) return;
    if (!document.getElementById('vk-hidden-only-marker')) return;
    _origFetch('/cart/clear.js', { method: 'POST' })
      .then(function () { return refreshDrawer(); })
      .catch(function () {});
  }

  function checkAndScheduleClear() {
    if (_swapping) return;
    clearTimeout(_clearDebounce);
    _clearDebounce = setTimeout(clearHiddenOnlyCart, 600);
  }

  function setupDrawerObserver() {
    // Watch #CartDrawer-CartItems — this is the element whose innerHTML Shrine
    // replaces via Section Rendering API, so the marker will appear here.
    var container = document.querySelector('#CartDrawer-CartItems');
    if (!container) {
      // Fallback: watch the whole drawer
      container = document.querySelector('#CartDrawer');
    }
    if (!container) return;

    // Check immediately on load
    checkAndScheduleClear();

    new MutationObserver(function () {
      checkAndScheduleClear();
    }).observe(container, { childList: true, subtree: true });
  }

  // Also watch the drawer's parent in case #CartDrawer-CartItems is replaced entirely
  function setupParentObserver() {
    var cartDrawer = document.querySelector('#CartDrawer');
    if (!cartDrawer) return;
    var parent = cartDrawer.parentElement;
    if (!parent) return;
    new MutationObserver(function () {
      if (!_swapping && document.getElementById('vk-hidden-only-marker')) {
        checkAndScheduleClear();
      }
    }).observe(parent, { childList: true, subtree: true });
  }

  // ─── Event delegation for upsell buttons ─────────────────────────────────────
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-vk-action]');
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    handleClick(el);
  });

  // ─── Init ─────────────────────────────────────────────────────────────────────
  function init() {
    setupDrawerObserver();
    setupParentObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
